import { openModal } from '@/services/bus';
import { isRecognizedEmailDomain } from '@/utils/email';
import { upperFirst } from 'lodash-es';

const openUpgradeModal = (config) =>
  openModal({ name: 'upgrade-team', variant: 'center', width: 600, closeButton: true, ...config });

export default {
  methods: {
    openUpgradeLockedModal(customSettings = {}) {
      const mode = 'light';
      const props = {
        title: 'Unlock more projects',
        content: 'Your team has run out of projects.\nUpgrade to unlock more projects.',
        mode,
        source: 'projects',
        ...customSettings
      };
      openUpgradeModal({ props, mode, onCloseRedirect: this.$route });
    },
    openUpgradeLockedScreensModal(customSettings = {}) {
      const mode = 'light';
      const props = {
        title: 'Unlock more screens',
        content: 'Your team has run out of screens.\nUpgrade to unlock more screens.',
        mode,
        source: 'screens',
        ...customSettings
      };
      openUpgradeModal({ props, mode, onCloseRedirect: this.$route });
    },
    openUpgradeDownloadCodeModal({ customSettings = {}, eventData = {} }) {
      const mode = 'dark';
      const props = {
        title: 'Unlock Pro features',
        content:
          'Upgrade to download project code package in a zip file including HTML & CSS files, images & fonts, with absolute position or Auto flex.',
        mode,
        source: 'omniview',
        nextPage: this.$route,
        ...customSettings
      };
      this.$trackEvent('omniview.paywall.show', eventData);
      openUpgradeModal({ props, mode, onCloseRedirect: this.$route });
    },
    getDefaultTeamName({ email, first_name: firstName }, forceUsingUsername = false) {
      const [emailUsername, emailDomain] = email.split('@');

      let ownerName;
      if (isRecognizedEmailDomain(email) || forceUsingUsername) {
        ownerName = firstName || emailUsername || 'my';
        if (firstName) ownerName = `${ownerName}’s`;
      } else {
        ownerName = emailDomain.split('.').shift();
      }

      return `${upperFirst(ownerName)} team`;
    }
  }
};
